import axios from "axios";
import { queryParams } from "../../../utils/queryParams";

const instance = axios.create({
  baseURL: queryParams.apiVersion + "pages/sales_activity/prospects_customers"
});

export const api = {
  getFilters(params) {
    return instance.post("/filters", params);
  },
  getCategories(params) {
    return instance.post("/filters/get_categories", params);
  },
  getProspects(params) {
    return instance.post("/prospects", params);
  },
  getCustomers(params) {
    return instance.post("/customers", params);
  },
  getFormerCustomers(params) {
    return instance.post("/former_customers", params);
  }
};
